export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "34666142671";
export const INSTAGRAM_HANDLE = "isisnails26";

export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
